"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChatErrorMessage = require("./ChatErrorMessage");
Object.keys(_ChatErrorMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatErrorMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ChatErrorMessage[key];
    }
  });
});